// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ScheduledJobs_HeartbeatResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ScheduledJobs_HeartbeatResponse — GET /scheduled-jobs/heartbeat.
 *
 * The DISPATCHER-level proof-of-life banner (as opposed to the PER-JOB
 * heartbeat already carried on every ScheduledJobs_JobRow.last_success_at /
 * .heartbeat_stale). last_tick_at advances on EVERY tick — jobs_due=0
 * included, the tick's own exception branch included (JobDispatcher writes
 * it in a finally) — so it is the one signal that tells "the cron died"
 * apart from "nothing was due right now", the exact ambiguity that let the
 * S4.4 sweep cron sit inert for weeks on a silently-404ing route.
 *
 * `ever_ticked=false` (no row yet — the dispatcher has literally never run
 * once) and `is_stale=true` (it HAS run, but not recently enough) are
 * distinct conditions the console must render differently — the tick period
 * is 5 minutes (docker-compose cron), so is_stale fires past 3× that.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface ScheduledJobs_HeartbeatResponseDados {
ever_ticked: boolean
is_stale: boolean
last_tick_at?: string
last_ok_at?: string
last_error?: string
jobs_due?: number
jobs_run?: number
}

export type ScheduledJobs_HeartbeatResponse = ApiResponse<ScheduledJobs_HeartbeatResponseDados>;

registerResponseContract('ScheduledJobs_HeartbeatResponse', {
  ever_ticked:  { type: 'boolean', required: true },
  is_stale:     { type: 'boolean', required: true },
  last_tick_at: { type: 'string',  required: false },
  last_ok_at:   { type: 'string',  required: false },
  last_error:   { type: 'string',  required: false },
  jobs_due:     { type: 'number',  required: false },
  jobs_run:     { type: 'number',  required: false },
})
